import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    image: data?.image,
    ...data?.localized_data,
  };
};

export const structure = (data, wrapId, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "file",
        label: t("common.image"),
        width: "100%",
      },
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("wrappers_colors.name_en")}*`,
        width: "47%",
        placeholder: t("wrappers_colors.write_name_en"),
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: `${t("wrappers_colors.name_ar")}*`,
        width: "47%",
        placeholder: t("wrappers_colors.write_name_ar"),
      },
      {
        name: `presentation`,
        kind: "colorInut",
        type: "text",
        label: `${t("wrappers_colors.pick_color")}*`,
        width: "47%",
        placeholder: t("wrappers_colors.pick_color_placeholder"),
      },
    ],
  },
];

export const validationSchema = (wrapId) =>
  Yup.object({
    en: Yup.object().shape({
      name: Yup.string().required("Required"),
    }),
    ar: Yup.object().shape({
      name: Yup.string().required("Required"),
    }),
    presentation: Yup.string().required("Required"),
    image: Yup.mixed(),
  });
